<template>
<div>
  <header :class="[isSticky ? 'sticky' : '']">
    <div class="header-area container">
      <div class="row menu-row">
        <div class="col-lg-9 col-sm-2 col-2 menu-items">
          <nav class="navbar navbar-expand-lg navbar-light">
            <button 
              class="navbar-toggler" 
              type="button" 
              role="button"
              data-toggle="collapse" 
              data-target="#navbarNav" 
              aria-controls="navbarNav" 
              aria-expanded="false" 
              aria-label="Toggle navigation"
            >
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNav">
              <scrollactive
                active-class="active"
                :offset="120"
                :duration="800"
                bezier-easing-value=".5,0,.35,1"
                v-on:itemchanged="onItemChanged"
              >
                <div id="nav" class="main-header-area">
                  <ul id="navigation" class="navbar-nav main-menu">
                    <li v-for="(menu, index) in menuItems" v-bind:key="index">
                      <a class="nav-item nav-link scrollactive-item" :href="`#${menu.section}`">
                        {{menu.title}}
                      </a>
                    </li>
                  </ul>
                </div>
              </scrollactive>
            </div>
          </nav>
        </div>
        <div class="col-lg-3 col-sm-10 col-10 contact-info text-right">
          <h5 class="phone">
            <i class="fa fa-phone"></i> 
            {{ phone }}
          </h5>
          <a class="facebook-link" href="https://www.facebook.com/profile.php?id=100008881572700" target="_blank">
            <i class="fa fa-facebook-square"></i>
          </a>
        </div>
      </div>
    </div>
  </header>
  <div class="go-to-top" v-if="isSticky" @click="goTop()">
    <i class="arrow-up fa fa-chevron-up"></i>
  </div>
</div>
</template>

<script>
import { PHONE } from '../constants';
export default {
  name: 'Header',
  data: function () {
    return {
      phone: PHONE,
      isSticky: false,
      menuSelected: 'home',
      topHeaderHeight: 0,
      menuItems: [
        {
          title: 'DESPRE MINE',
          section: 'home'
        },
        {
          title: 'ARII DE EXPERTIZA',
          section: 'domains'
        },
        {
          title: 'CONTACT',
          section: 'contact'
        },
        {
          title: 'SEDIU',
          section: 'sediu'
        }
      ]
    }
  },
  methods: {
    navigate(title) {
      this.menuSelected = title;
      this.$emit('menuNavigation', title);
    },
    goTop() {
      window.scroll({ top: 0, behavior: "smooth" });
    },
    onItemChanged(event, currentItem, lastActiveItem) {
      if(lastActiveItem) {
        lastActiveItem.blur();
      }
    },
  },
  mounted(){
    let navBar = document.getElementById('home');
    this.topHeaderHeight = navBar.offsetHeight;
    
    window.document.onscroll = () => {
      if(window.scrollY >= this.topHeaderHeight){ 
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }      
    }
  }
}
</script>
<style scoped lang="scss">
@import "../scss/_variables.scss";
#navigation {
  margin-bottom: 0;
  padding-left: 0;
  padding-right: 0;
}

nav {
  padding: 0;
}

.sticky {
  box-shadow: 0px 3px 16px 0px rgb(0, 0, 0 / 10%);
  border-bottom: 1px solid $border-color;
  position: fixed;
  width: 100%;
  top: -71px;
  left: 0;
  right: 0;
  z-index: 99;
  transform: translateY(70px);
  transition: transform 500ms ease, background 500ms ease;
  -webkit-transition: transform 500ms ease, background 500ms ease;
  background: #000;
}

header {
  background-color: $bg-color;
}

.navbar-toggler {
  background-color: #f2c64d;
  margin: 20px 0;
}

.header-area {
  left: 0;
  right: 0;
  background: 0 0;
  z-index: 999;
  background-color: $bg-color;

  .contact-info {
    align-self: normal;
    color: $theme-color;
    font-size: 25px;

    .phone {
      display: inline-block;
      margin-right: 20px;
    }

    .facebook-link {
      color: $theme-color;
    }
  }
  .align-items-center {
    -webkit-box-align: center!important;
    -ms-flex-align: center!important;
    align-items: center!important;
  }

  .menu-row {
    align-items: center;
  }

  ul.main-menu li {
    display: inline-block;
    position: relative;
    a {
      color: #fff;
      font-size: 15px;
      font-weight: 400;
      display: inline-block;
      font-family: poppins,sans-serif;
      position: relative;
      line-height: 3;
      padding: 0;

      &:hover {
        color: $theme-color;
        cursor: pointer;
        text-decoration: none;
        border-bottom: 2px solid $theme-color;
      }
    }

    a.active {
      border-bottom: 2px solid $theme-color;
      color: $theme-color;
    }
  }

  .contact-info {
    color: $theme-color;
  }
}

.go-to-top {
  position: fixed;
  width: 60px;
  height: 60px;
  right: 4.5%;
  bottom: 35px;
  z-index: 1000;
  color: $white;
  background-color: $theme-color;
  box-shadow: transparent 0px 0px 0px;
  border-radius: 50%;
  box-shadow: rgb(0, 0, 0 / 30%) 1px 1px 2px;
}
.go-to-top:hover {
  cursor: pointer;
}
.arrow-up {
  position: relative;
  top: 24%;
  left: 28%;
  font-size: 25px;
}
@media only screen and (min-width: 992px) {
  .main-header-area {  
    ul.main-menu li {
      padding: 25px 35px 25px 0;
    }
  }

  .contact-info {
    align-self: center !important;
  }
}
@media only screen and (max-width: 992px) { 
  #navigation {
    width: 100vw;
  }
  .contact-info {
    margin: 19px 0;
  }
  #navbarNav {
    padding-bottom: 15px;
  }
  .main-header-area {  
    ul.main-menu li {
      height: 47px;
    }
  }
  .menu-items {
    z-index: 999999;
  }
}
</style>
